let _this;
export default{
    name:'quick-set-dcs',
    data(){
        return {
            editDcsModal: false,
            checkAllDcs: false,
            dcsAccessFlag: false,
            dcsAutoFlag: false,
            allZoneList: [],
            zoneList: [],
            specialZoneList: [],
            autoZoneListStart: [],
            autoZoneListEnd: [],
            editDcsInfo: {},
            defaultZoneIds: [],
        }
    },
    mounted(){
        _this = this;
    },
    methods:{
        getDCSZoneList: function () {
            _this.$ajax.post('DCSZone/QueryOption', {},{headers:{noLoading:true}}).then((res)=> {
              if (res.data.success) {
                _this.zoneList = [];
                _this.specialZoneList = [];
                _this.allZoneList = JSON.parse(JSON.stringify(res.data.data));
                res.data.data.forEach(val => {
                  if(val.isEnableSpecial) {
                    if (val.isSpecial) {
                      _this.specialZoneList.push(val);
                    } else {
                      if (val.isDefault) {
                        _this.defaultZoneIds.push(val.id);
                      }
                      _this.zoneList.push(val);
                    }
                  }else {
                    _this.zoneList.push(val);
                  }
                });
              } else {
                _this.messageNotice("error",res.data.message);
              }
            })
          },
          isCheckAll(){
            _this.$nextTick(()=>{
              let accessZoneIds = JSON.parse( JSON.stringify(_this.editDcsInfo.normalZoneIds) );
              let zoneList = _this.zoneList.filter(val => {
                return !val.isEnableSpecial;
              });
              let selZones = [];
              if( zoneList.length ){
                selZones = zoneList.filter((item)=>{
                  return accessZoneIds.indexOf( item.id ) > -1;
                })
                if(selZones.length === zoneList.length){
                  _this.checkAllDcs = true;
                }else{
                  _this.checkAllDcs = false;
                }
              }else{
                _this.checkAllDcs = false;
              }
            })
          },
          quickEditDcs(data){
            _this.autoZoneListStart = [];
            _this.autoZoneListEnd = [];
            _this.defaultZoneIds = [];
            _this.dcsAccessFlag = false;
            _this.dcsAutoFlag = false;
            _this.getDCSZoneList();
            _this.$ajax.get('User/QuickQueryUserDcsZone?id=' + data.id, {headers:{noLoading:true}}).then((res)=> {
              if (res.data.success) {
                let data = res.data.data;
                _this.editDcsInfo = {
                  zoneIds : data.zoneIds,
                  normalZoneIds:[],
                  specialZoneIds:[],
                  userId: data.userId,
                  startZoneId: data.startZoneId,
                  endZoneId : data.endZoneId
                }
                _this.editDcsInfo.zoneIds.forEach(val => {
                  let index = _this.zoneList.findIndex(sin => {
                    return sin.id === val;
                  })
                  if(index > -1){
                    _this.editDcsInfo.normalZoneIds.push(val);
                  } else {
                    _this.editDcsInfo.specialZoneIds.push(val);
                  }
                })
                _this.defaultZoneIds.forEach(val => {
                  if(_this.editDcsInfo.normalZoneIds.indexOf(val) === -1){
                    _this.editDcsInfo.normalZoneIds.push(val);
                  }
                })
                _this.handleAutoZone(_this.editDcsInfo.normalZoneIds);
                _this.isCheckAll();
              }
              if(!res.data.data.startZoneId){
                _this.editDcsInfo.startZoneId = "all";
              }
              _this.editDcsModal = true;
            })
          },
          saveDcsInfo(){
            _this.dcsAccessFlag = false;
            _this.dcsAutoFlag = false;
            if(!(_this.editDcsInfo.normalZoneIds.length > 0 || _this.editDcsInfo.specialZoneIds.length > 0) && _this.ApiService.isMandatory){
              _this.dcsAccessFlag = true;
            }
            if(!(_this.editDcsInfo.startZoneId && _this.editDcsInfo.endZoneId) && _this.ApiService.isMandatory){
              _this.dcsAutoFlag = true;
            }
            if(!(_this.dcsAccessFlag || _this.dcsAutoFlag)){
              let data = {
                userId: _this.editDcsInfo.userId,
                zoneIds: [],
                startZoneId: _this.editDcsInfo.startZoneId === "all" ? null : _this.editDcsInfo.startZoneId,
                endZoneId: _this.editDcsInfo.endZoneId
              }
              if(_this.editDcsInfo.specialZoneIds && _this.editDcsInfo.specialZoneIds.length > 0){
                data.zoneIds = _this.editDcsInfo.normalZoneIds.concat(_this.editDcsInfo.specialZoneIds);
              } else {
                data.zoneIds = _this.editDcsInfo.normalZoneIds;
              }
              data.zoneIds = data.zoneIds.filter(val => {
                return val.length > 10;
              })
              _this.$ajax.post('User/QuickEditUserDcsZone', data,).then((res)=> {
                if (res.data.success) {
                  _this.messageNotice('success');
                  _this.editDcsModal = false;
                  _this.getTableData();
                } else {
                  _this.messageNotice("error",res.data.message);
                }
              })
            }
          },
          handleCheckAllDcs(){
            let selZoneIds = JSON.parse(JSON.stringify(_this.editDcsInfo.normalZoneIds));
            let zoneList = _this.zoneList.filter(val => {
              return !val.isEnableSpecial;
            });
            // 全选
            if(_this.checkAllDcs){
              zoneList.forEach((item)=>{
                if( selZoneIds.indexOf( item.id ) === -1 ){
                  selZoneIds.push( item.id );
                }
              })
              // 如果没有end auto zone, 选择第一个
              if( selZoneIds.length ){
                _this.editDcsInfo.endZoneId = selZoneIds[0];
              }
            }else{
              // 取消所有选择
              selZoneIds = JSON.parse(JSON.stringify(_this.defaultZoneIds));
              _this.editDcsInfo.startZoneId = "all";
              _this.editDcsInfo.endZoneId = null;
            }
            _this.autoZoneListStart = [];
            _this.autoZoneListEnd = [];
            _this.handleAutoZone(selZoneIds);
            _this.$set(_this.editDcsInfo,"normalZoneIds",selZoneIds);
          },
          checkDcsZone(val){
            _this.isCheckAll();
            _this.autoZoneListStart = [];
            _this.autoZoneListEnd = [];
            _this.handleAutoZone(val);
          },
          handleAutoZone(val){
            let allZoneIds = [];
            if(_this.editDcsInfo.specialZoneIds && _this.editDcsInfo.specialZoneIds.length > 0){
              allZoneIds = val.concat(_this.editDcsInfo.specialZoneIds)
            } else {
              allZoneIds = val;
            }
            allZoneIds.forEach(val => {
              let index = _this.allZoneList.findIndex(sin => {
                return sin.id === val && _this.ApiService.noStartZone.indexOf(sin.id) == -1 && !sin.isVirtual;
              })
              if(index > -1){
                _this.autoZoneListStart.push(_this.allZoneList[index]);
              }
            })
            allZoneIds.forEach(val => {
              let index = _this.allZoneList.findIndex(sin => {
                return sin.id === val && _this.ApiService.noEndZone.indexOf(sin.id) == -1 && !sin.isVirtual;
              })
              if(index > -1){
                _this.autoZoneListEnd.push(_this.allZoneList[index]);
              }
            })
            _this.autoZoneListStart.sort(sortFun);
            _this.autoZoneListEnd.sort(sortFun);
            if(_this.editDcsInfo.startZoneId && _this.editDcsInfo.startZoneId !== "all"){
              let index = _this.autoZoneListStart.findIndex(sin => {
                return sin.id === _this.editDcsInfo.startZoneId;
              })
              if(index === -1){
                _this.editDcsInfo.startZoneId = "all"
              }
            }
            if(_this.editDcsInfo.endZoneId){
              let index = _this.autoZoneListEnd.findIndex(sin => {
                return sin.id === _this.editDcsInfo.endZoneId;
              })
              if(index === -1){
                _this.editDcsInfo.endZoneId = null;
              }
            }
            // 按字母排序
            function sortFun(a,b){
              let value1 = parseInt(a.name.replace(/[^\d]/g, ""));
              let value2 = parseInt(b.name.replace(/[^\d]/g, ""));
              return value1 - value2;
            }
          },
    }
}


// WEBPACK FOOTER //
// ./src/admin/components/fastRegistration/quickSetDCSZone.js